// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"b7fadcfa","22":"c21f2bf6","77":"21920f8f","446":"316c0052","534":"a56edfb4","565":"cd755933","726":"0a6e89ca","787":"f24d569d"}[chunkId] + ".chunk.js";
};